import {
  provideAllowedOsUpdatesStore,
  provideDeviceActiveSyncsStore,
  provideDeviceAssignmentHistoryStore,
  provideDeviceConfiguredApplicationsStore,
  provideDeviceInstalledApplicationsStore,
  provideDeviceScheduledTasksStore,
  provideDeviceSyncStatusesStore,
  providePairingStore,
} from '@era/devices';
import {
  provideAppleApplicationsStore,
  provideAppleDeviceProfileStore,
  provideAppleProfilePresetStore,
  provideAppleProfileStore,
  provideApplicationsConfiguredSettingsStore,
  provideAvailableOsUpdatesStore,
  provideCategoryAirplaySecurityProfilePresetConfigurationStore,
  provideCategoryApplicationsStore,
  provideCategoryAppLockStore,
  provideCategoryAppSettingsStore,
  provideCategoryRestrictionProfilePresetConfigurationStore,
  provideCategoryStore,
  provideCategoryVppApplicationsStore,
  provideCategoryWifiProfilePresetConfigurationStore,
  provideCommandContentStore,
  provideCommandProgressStore,
  provideDeviceLocationStore,
  provideDevicesOsUpdateStatusStore,
  provideDeviceStore,
  provideFloorAclStore,
  provideFloorStore,
  provideGroupsOfGroupStore,
  provideGroupStore,
  provideInstalledApplicationsStore,
  provideIntegratedIReckonHotelStore,
  provideIntegratedIReckonRoomStore,
  provideLocationAclStore,
  provideLocationAllowedOsUpdatesStore,
  provideManagementTokensStore,
  provideMemberGroupStore,
  provideMemberUserStore,
  provideNotesStore,
  provideRoomAclStore,
  provideScheduledApplicationsStore,
  provideSuggestedUserStore,
  provideUnenrolledDeviceStore,
  provideUserGroupAclStore,
  provideUserGroupStore,
  provideUserStore,
  provideVppApplicationsStore,
  routerStoreProvider,
} from '@era/stores';
import { provideManagedApplicationsStore, provideManagedSettingsStore } from '@rocksoft/mdm';

export function provideAppStores() {
  return [
    ...provideAppleDeviceProfileStore(),
    ...provideAppleProfilePresetStore(),
    ...routerStoreProvider(),
    ...provideCategoryStore(),
    ...provideGroupStore(),
    ...provideUserStore(),
    ...provideUserGroupStore(),
    ...provideMemberUserStore(),
    ...provideMemberGroupStore(),
    ...provideSuggestedUserStore(),
    ...provideFloorStore(),
    ...provideIntegratedIReckonHotelStore(),
    ...provideIntegratedIReckonRoomStore(),
    ...provideDeviceStore(),
    ...provideAppleProfileStore(),
    ...provideCategoryAppLockStore(),
    ...provideInstalledApplicationsStore(),
    ...provideLocationAclStore(),
    ...provideFloorAclStore(),
    ...provideRoomAclStore(),
    ...provideUserGroupAclStore(),
    ...provideGroupsOfGroupStore(),
    ...provideVppApplicationsStore(),
    ...provideCategoryAirplaySecurityProfilePresetConfigurationStore(),
    ...provideCategoryApplicationsStore(),
    ...provideCategoryRestrictionProfilePresetConfigurationStore(),
    ...provideCategoryVppApplicationsStore(),
    ...provideCategoryWifiProfilePresetConfigurationStore(),
    ...provideAppleApplicationsStore(),
    ...provideLocationAllowedOsUpdatesStore(),
    ...provideCommandProgressStore(),
    ...provideCommandContentStore(),
    ...provideUnenrolledDeviceStore(),
    ...provideManagementTokensStore(),
    ...provideAvailableOsUpdatesStore(),
    ...provideScheduledApplicationsStore(),
    ...provideDeviceLocationStore(),
    ...provideCategoryAppSettingsStore(),
    ...provideApplicationsConfiguredSettingsStore(),
    ...provideNotesStore(),
    ...provideDevicesOsUpdateStatusStore(),
    ...providePairingStore(),

    // mdm:
    ...provideManagedApplicationsStore(),
    ...provideManagedSettingsStore(),

    // devices:
    ...provideDeviceConfiguredApplicationsStore(),
    ...provideDeviceInstalledApplicationsStore(),
    ...provideDeviceActiveSyncsStore(),
    ...provideDeviceAssignmentHistoryStore(),
    ...provideDeviceSyncStatusesStore(),
    ...provideDeviceActiveSyncsStore(),
    ...provideDeviceScheduledTasksStore(),
    ...provideAllowedOsUpdatesStore(),
  ];
}
